import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=491a3b7b&scoped=true"
import script from "./GettingStarted.vue?vue&type=script&lang=js"
export * from "./GettingStarted.vue?vue&type=script&lang=js"
import style0 from "./GettingStarted.vue?vue&type=style&index=0&id=491a3b7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a3b7b",
  null
  
)

export default component.exports